import React, { FC } from "react";

import { pagePathUtils } from "~/utils";

import {
  useApisMembersNavigationItemsIndex,
  useProvidersCurrentEmployee,
} from "~/hooks";

import { AnalyticsPlanSidebar } from "./AnalyticsPlanSidebar";
import { ManagerSidebar } from "./ManagerSidebar";
import { MemberSidebar } from "./MemberSidebar";

import {
  ManagerOrOwnerRoles,
  ApiMembersUnreadNotificationCountsType,
} from "~/domains";

type PropsType = {
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
};

export const HomeSidebar: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
}: PropsType) => {
  const { currentEmployee } = useProvidersCurrentEmployee();
  const isManagerPage = pagePathUtils.isManagerPage();
  const isAnalyticsPlans = pagePathUtils.isAnalyticsPlansPage();
  const isManagerOver = ManagerOrOwnerRoles.some(
    (role) => role.id === currentEmployee?.employeeRole?.id,
  );
  const managerSidebarViewable = isManagerPage && isManagerOver;
  const { data: settingsData } = useApisMembersNavigationItemsIndex();

  return (
    <div className="miniTablet:mb-16">
      {isAnalyticsPlans ? (
        <AnalyticsPlanSidebar breadCrumbText={breadCrumbText} />
      ) : managerSidebarViewable ? (
        <ManagerSidebar
          breadCrumbText={breadCrumbText}
          unreadNotification={unreadNotification}
          navigationItems={settingsData?.navigationItems}
        />
      ) : (
        <MemberSidebar
          breadCrumbText={breadCrumbText}
          unreadNotification={unreadNotification}
          navigationItems={settingsData?.navigationItems}
        />
      )}
    </div>
  );
};
